import * as React from "react";
import { indicesInWarmTier, isSearchingWarmTier } from "views/components/searchbar/queryvalidation/warmTierValidation";
import { Explanation } from "views/components/searchbar/queryvalidation/QueryValidation";
import WarmTierErrorMessage from "views/components/searchbar/queryvalidation/WarmTierErrorMessage";
const WarmTierQueryValidation = ({ validationState }) => {
  const warmTierIndices = indicesInWarmTier(validationState);
  if (!isSearchingWarmTier(warmTierIndices)) return null;
  return /* @__PURE__ */ React.createElement(Explanation, null, /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("b", null, "Warm Tier Search"), ": ", /* @__PURE__ */ React.createElement(WarmTierErrorMessage, { warmTierIndices })));
};
export default WarmTierQueryValidation;
